const config = {
    apiGtwUrl: process.env.REACT_APP_API_GTW,
    api_getById_url: process.env.REACT_APP_GETBYID_API_URL
    // Autres variables d'environnement
  };
  
  export default config;
  